export default __webpack_public_path__ + "static/media/01.41f4a824.png";